var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseEditable',_vm._g({ref:"editable",staticClass:"d-inline-block",attrs:{"tag":"span","content":_vm.price,"placeholder":_vm.placeholder,"mods":_vm.price}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }